const MessageConstants = {}

MessageConstants.EXPIRED_TOKEN_RESET = 'Sorry! This link has expired to keep your account secure. Just type in the email you use to sign in with Drift, and we’ll send you a new link!'
MessageConstants.EXPIRED_TOKEN_ACCEPT = 'Sorry! This link has expired or has already been used.'
MessageConstants.DEFAULT_SERVER_ERROR = 'Something went wrong, please try again.'
MessageConstants.INVALID_TOKEN = 'You have an invalid token.'
MessageConstants.LOGIN_BAD_INPUT = 'Sorry, you entered an incorrect email address or password.'
MessageConstants.FORGOT_PASSWORD_NO_ACCOUNT = 'Sorry, we don\'t have that email in our system.'
MessageConstants.SENT_PASSWORD_RESET = 'Look out for an email from us with instructions on how to reset your password!'
MessageConstants.FORGOT_HELPER = 'To reset your password, enter the email that you use to sign in to Drift.'
MessageConstants.PASSWORD_RESET_SUCCESS = 'Your password has been changed successfully! You will be logged in momentarily.'
MessageConstants.USER_NOT_FOUND = 'Sorry! The user associated with this link was not found. Contact your admin for more details.'

export default MessageConstants
